// Func = limiting Scope for this file
var lastScrollTop = 0
;(function () {
	$(document).ready(function () {

		let form_id_3150 = document.querySelector( "#form_id-3150" );
		if( form_id_3150 ){
			form_id_3150.querySelector( "[name=select_your_ideal_venue]" )
			form_id_3150.addEventListener( "change", (e) => {

				let val = e.target.value;

				switch( val ){

					case "fireside_lounge":
						form_id_3150.querySelector( "[name=sendto]" ).value = "dos@firesideinncambria.com"
						break;
					case "_fogcatcher_breakfast_room":
						form_id_3150.querySelector( "[name=sendto]" ).value = "dos@fogcatcherinn.com"
						break;
					case "oceanpoint_ranch_event_and_meeting_spaces":
						form_id_3150.querySelector( "[name=sendto]" ).value = "dos@oceanpointranch.com"
						break;

				}

			} )
		}

		setTimeout(function () {
			$.each($('#attractions-wrapper .learn-more-btn'), function () {
				$(this).attr('aria-label', 'Learn more of ' + $(this).parent().find('h2').text())
			})
		}, 2000)

		// Pop-in add x
		if ($('#content-popin').length > 0) {
			$('#content-popin .box-content-popin').append('<div class="close-popin"></div>')
			$('#content-popin .close-popin').click(function () {
				$('.box-arrow-popin .arrow').addClass('open')
				$('.box-content-popin').removeClass('open')
				TogglePopIn()
			})
		}

		$('#accommodations .expand-link').click(function (e) {
			e.preventDefault()
		})

		var currentMenuItem = $('.header .privary-navigation a.active').parent().index()

		$('.menu-hovers .slide:eq(' + currentMenuItem + ')').addClass('active')
		$('.header .privary-navigation li > a').hover(function () {
			//console.log($(".header .privary-navigation li > a"));
			var corrimiento = $(this).closest('li').prevAll().find('.privary-navigation__submenu a').length
			var hoverItem = $(this).parent().index() + corrimiento
			//console.log($(this).parent().index());
			$('.menu-hovers .slide').removeClass('active')
			$('.menu-hovers .slide:eq(' + hoverItem + ')').addClass('active')
		})

		$('.header .privary-navigation__item .privary-navigation__submenu .privary-navigation__item  a').hover(function () {

			let containerOfElementOnHover = $(this).parents('.privary-navigation__item').last()[0];
			let elementOnHover = $(this)[0];
			let indexElementOnHover = null;
			containerOfElementOnHover.querySelectorAll('ul li a').forEach( (ele, index) => {
				if( ele == elementOnHover){
					indexElementOnHover = index;
				}
			} );
			//var corrimiento = $(this).parents('.privary-navigation__item').last().prevAll().find('.privary-navigation__submenu a').length
			var hoverItem = $(this).parents('.privary-navigation__item').last().index() + indexElementOnHover

			// console.log($(this).parent().index())
			$('.menu-hovers .slide').removeClass('active')
			$('.menu-hovers .slide:eq(' + hoverItem + ')').addClass('active')
		})

		$('.menu-toggle,.close-menu').click(function (e) {
			e.preventDefault()
			$('#menu').toggleClass('opened')
		})
		$('.be-toggle,.close-be').click(function (e) {
			e.preventDefault()
			$('#booking-overlay').toggleClass('opened')
			$('body').toggleClass('opened-be')
		})
		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover')
				$('ul.submenu', this).fadeIn(200)
			},
			function () {
				$(this).removeClass('hover')
				$('ul.submenu', this).fadeOut(200)
			},
		)
		$('#home-intro').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$("#home-intro .slide[data-slick-index='" + nextSlide + "']").addClass('zoom-in')
		})
		$('#home-intro').on('afterChange', function (slick, currentSlide) {
			$('#home-intro .slide:not(.slick-active)').removeClass('zoom-in')
		})

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true]
		const DATE_FORMATLP = $('#landing_check_in').data('format') !== undefined && $('#landing_check_in').data('format') ? $('#landing_check_in').data('format') : 'yy-mm-dd'
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top'
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight'
			} else {
				DATE_STYLE[1] = ''
			}
			return DATE_STYLE
		}
		function calendarRangeLP(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMATLP, $('#landing_check_in').val())
			let d2 = $.datepicker.parseDate(DATE_FORMATLP, $('#landing_check_out').val())
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top'
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight'
			} else {
				DATE_STYLE[1] = ''
			}
			return DATE_STYLE
		}
		$('#CheckIn, #CheckOut, #CheckIn2, #CheckOut2').on('focusout', function () {
			var currentDate = $(this).val()
			var dateFormat = $('#CheckIn-alt').data('format')
			if (currentDate != '') {
				currentDate = currentDate.replace(/\//g, '-')
				var splitDate = currentDate.split('-')
				if (splitDate[0] < 10 && splitDate[0][0] != 0) {
					splitDate[0] = '0' + splitDate[0]
				}
				if (splitDate[1] < 10 && splitDate[1].indexOf(0) != 0) {
					splitDate[1] = '0' + splitDate[1]
				}
				$(this).val(splitDate[0] + '-' + splitDate[1] + '-' + splitDate[2])
				if (dateFormat == 'yy-mm-dd') {
					$(this)
						.siblings('input')
						.val(splitDate[2] + '-' + splitDate[0] + '-' + splitDate[1])
				} else {
					$(this)
						.siblings('input')
						.val(splitDate[0] + '-' + splitDate[1] + '-' + splitDate[2])
				}
			}
		})
		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'mm-dd-yy'
		// $( "#CheckIn" ).datepicker({
		// 	//showOn: "both",
		// 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		// 	//buttonImageOnly: true,
		// 	changeMonth: true,
		//     dateFormat: 'mm-dd-yy',
		//     numberOfMonths: 1,
		// 	minDate: 0,
		// 	beforeShowDay: (date) => calendarRange(date),
		// 	onSelect: function( selectedDate ) {
		// 		let getDate = $(this).datepicker('getDate');
		// 		let newDate = new Date(getDate.getTime());
		// 		newDate.setDate(newDate.getDate() + 3);
		// 		$( "#CheckOut" ).datepicker( "setDate", newDate );
		// 		$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		// 	}
		// });
		// $( "#CheckOut" ).datepicker({
		// 	//showOn: "both",
		// 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		// 	//buttonImageOnly: true,
		//     dateFormat: 'mm-dd-yy',
		//     changeMonth: true,
		// 	numberOfMonths: 1,
		// 	beforeShowDay: (date) => calendarRange(date),
		// 	onSelect: function( selectedDate ) {
		// 		//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		// 	}
		// });
		//Check in and check out datepicker for booking engine
		const DATE_FORMAT2 = $('#CheckIn2').data('format') !== undefined && $('#CheckIn2').data('format') ? $('#CheckIn2').data('format') : 'mm-dd-yy'

		$('#CheckIn2').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			changeYear: true,
			dateFormat: site_id_cambria == 1348 ? 'mm/dd/yy' : 'mm-dd-yy',
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut2').datepicker('setDate', newDate)
				$('#CheckOut2').datepicker('option', 'minDate', selectedDate)
			},
		})
		$('#CheckOut2').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: site_id_cambria == 1348 ? 'mm/dd/yy' : 'mm-dd-yy',
			changeMonth: true,
			changeYear: true,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})
		$('#CheckInCambria').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			changeYear: true,
			dateFormat: site_id_cambria == 1348 ? 'mm/dd/yy' : 'mm-dd-yy',
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				$('#CheckIn2-alt').val(selectedDate)
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOutCambria').datepicker('setDate', newDate)
				$('#CheckOutCambria').datepicker('option', 'minDate', selectedDate)
				let daycambria = newDate.getDate()
				let monthcambria = newDate.getMonth() + 1
				let yearcambria = newDate.getFullYear()
				$('#CheckOut2-alt').val(monthcambria + '-' + daycambria + '-' + yearcambria)
			},
		})
		$('#CheckOutCambria').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: site_id_cambria == 1348 ? 'mm/dd/yy' : 'mm-dd-yy',
			changeMonth: true,
			changeYear: true,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				$('#CheckOut2-alt').val(selectedDate)
			},
		})
		$('#landing_check_in').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			changeYear: true,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#landing_check_out').datepicker('setDate', newDate)
				$('#landing_check_out').datepicker('option', 'minDate', selectedDate)
			},
		})

		$('#landing_check_out').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: 'mm-dd-yy',
			changeMonth: true,
			changeYear: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})
		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$('#booking-form2').on('submit', function () {
			var CheckInAlt = $('#CheckIn2').val()
			var CheckOutAlt = $('#CheckOut2').val()
			var dateFormat = $('#CheckIn-alt').data('format')
			if (dateFormat == 'yy-mm-dd') {
				var checkIn_split = CheckInAlt.split('-')
				var checkOut_split = CheckOutAlt.split('-')
				$('#CheckIn2-alt').val(checkIn_split[2] + '-' + checkIn_split[0] + '-' + checkIn_split[1])
				$('#CheckOut2-alt').val(checkOut_split[2] + '-' + checkOut_split[0] + '-' + checkOut_split[1])
			} else {
				$('#CheckIn2-alt').val(CheckInAlt)
				$('#CheckOut2-alt').val(CheckOutAlt)
			}
		})

		const onEventsBooking = () => {
			let elementSpecials = document.querySelectorAll('.specials-rate')
			let elementSpecialsInput = document.querySelectorAll('.inline-promo')

			elementSpecials.forEach((element) => {
				let inputPrevius = element.previousElementSibling
				if (inputPrevius === null) return

				let idInput = inputPrevius.getAttribute('id')
				let inputToChange = 'inline-promo, promo'

				if (inputToChange.indexOf(idInput) !== -1) {
					element.addEventListener('change', function (event) {
						let target = event.target
						target && inputPrevius.setAttribute('name', target.value)

						// set maxlenght
						if (target.value === 'corporateCode') {
							inputPrevius.setAttribute('maxlength', '10')
						} else if( target.value === 'promoCode' ){
							if ( document.querySelector('body.site-1365') || document.querySelector('body.site-1362') || document.querySelector('body.site-1359') ) {
								inputPrevius.setAttribute('maxlength', '10')
							} else {
								inputPrevius.setAttribute('maxlength', '6')
							}
						} else {
							inputPrevius.setAttribute('maxlength', '6')
						}

						// validation is error
						let boxError = target.nextElementSibling
						if (inputPrevius.value !== '' && target.value !== '') {
							boxError = boxError !== null ? boxError.classList.remove('error') : null
						} else if (inputPrevius.value !== '' && target.value === '') {
							boxError = boxError !== null ? boxError.classList.add('error') : null
						}
					})
				}
			})

			elementSpecialsInput.forEach((element) => {
				let selectNext = element.nextElementSibling
				if (selectNext === null) return

				let idSelect = selectNext.getAttribute('id')
				let selectToChange = 'inline-specials-rate, specials-rate'

				if (selectToChange.indexOf(idSelect) !== -1) {
					element.addEventListener('focus', function (event) {
						let target = event.target
						let boxError = selectNext.nextElementSibling

						if (target && selectNext.value === '') {
							boxError = boxError !== null ? boxError.classList.add('error') : null
						} else {
							boxError = boxError !== null ? boxError.classList.remove('error') : null
						}
					})

					element.addEventListener('blur', function (event) {
						let target = event.target
						let boxError = selectNext.nextElementSibling

						if (target.value === '' && selectNext.value === '') {
							boxError = boxError !== null ? boxError.classList.remove('error') : null
						}
					})
				}
			})
		}

		onEventsBooking()
	})

	$(window).on('load', function(){
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
			// if ($(".inline-be").length > 0) {
			// 	var inlineBEOffset = $(".inline-be").offset().top;
			// 	if (document.documentElement.scrollTop > inlineBEOffset) {
			// 	$(".header").addClass("show-btn");
			// 	} else {
			// 	$(".header").removeClass("show-btn");
			// 	}
			// }
		})
	})
	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		// scrollDownAction(20, 'scroll');
	}

})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}
